import React from "react";
import { Container, Header, Row, Title, About } from "../components";
import { DescSkillsContainer, ParcoursContainer } from "../containers";

const AboutPage: React.FC = () => (
  <About>
    <Container>
      <Row>
        <Header>
          <Title>about me</Title>
        </Header>
      </Row>
      <Row>
        <About.Image />
        <About.Content>
          <DescSkillsContainer />
          <ParcoursContainer />
        </About.Content>
      </Row>
    </Container>
  </About>
);

export default AboutPage;
